export default __webpack_public_path__ + "static/media/gucci_x_mad_2_lowdef.175c8dd7.png";